import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const vehicleApi = createApi({
	reducerPath: "vehicle",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getVehicles: builder.query({
			query: () => `/vehicle/queryAllVehicleData`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getVehiclesByDate: builder.query({
			query: (date) =>
				`/vehicle/queryAllVehicleDataWithDate?travelDate=${date}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getVehiclesByDateByListId: builder.query({
			query: (id, date) =>
				`/vehicle/queryVehicleDataWithIdAndDate?travelDate=${date}&listId=${id}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		getVehiclesByDateByProductId: builder.query({
			query: ({ id, date }) =>
				`/vehicle/queryAvailableVehicleDataWithDate?travelDate=${date}&productId=${id}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),

		deleteVehicle: builder.mutation({
			query(id) {
				return {
					url: `/vehicle/deleteVehicleData?vehicleId=${id}`,
					method: "DELETE",
				};
			},
		}),
		addVehicle: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/vehicle/insertVehicleData",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateVehicle: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/vehicle/updateVehicleData",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
	}),
});

export const {
	useGetVehiclesQuery,
	useGetVehiclesByDateQuery,
	useGetVehiclesByDateByListIdQuery,
	useGetVehiclesByDateByProductIdQuery,
	useAddVehicleMutation,
	useDeleteVehicleMutation,
	useUpdateVehicleMutation,
} = vehicleApi;
